import { Reveal, RevealWords } from "../ui/Reveal";

type Props = {
  label: string;
  title: string;
  intro?: readonly string[];
  dark?: boolean;
  align?: "center" | "split" | "left";
};

export function SecHead({ label, title, intro, dark = false, align = "center" }: Props) {
  if (align === "split" && intro && intro.length > 0) {
    return (
      <div className="sechead split">
        <div className="sechead-l">
          <Reveal>
            <span className={`eyebrow ${dark ? "on-dark" : ""}`}>{label}</span>
          </Reveal>
          <RevealWords as="h2" className="h-sec sechead-title" text={title} />
        </div>
        <div className="sechead-r sechead-intro body">
          {intro.map((p, i) => (
            <RevealWords key={i} text={p} />
          ))}
        </div>
      </div>
    );
  }
  return (
    <div className={`sechead ${align}`}>
      <Reveal>
        <span className={`eyebrow ${dark ? "on-dark" : ""}`}>{label}</span>
      </Reveal>
      <RevealWords as="h2" className="h-sec sechead-title" text={title} />
      {intro && (
        <div className="sechead-intro body">
          {intro.map((p, i) => (
            <RevealWords key={i} text={p} />
          ))}
        </div>
      )}
    </div>
  );
}
